// T9 hash → search 兼容：
// 老 SSR 页面常用 #tab=maps 形式带 UI 状态；迁移到 SPA 时必须把这种 hash
// 改写成 search params，否则 router validateSearch 拿不到。
// 规则：
//   - hash 必须包含 `=` 才视为 key=value 列表（避免误改纯锚点 #section1）。
//   - 多对用 `&` 分隔，例如 #tab=maps&page=3。
//   - 已存在的 search 优先（不覆盖）。
//   - 写回时去掉 hash。

export interface HashRewriteResult {
  rewrote: boolean;
  search: Record<string, string>; // 合并后的 search（含原 search）
  hash: string; // 处理后的 hash（要么空，要么保留的纯锚点）
}

export function planHashRewrite(rawHash: string, rawSearch: string): HashRewriteResult {
  const hash = rawHash.startsWith("#") ? rawHash.slice(1) : rawHash;
  if (!hash || !hash.includes("=")) {
    return { rewrote: false, search: parseSearch(rawSearch), hash: rawHash };
  }
  // 尝试以 URLSearchParams 解析
  const merged = parseSearch(rawSearch);
  const fromHash = new URLSearchParams(hash);
  let rewrote = false;
  for (const [k, v] of fromHash) {
    if (!(k in merged)) {
      merged[k] = v;
      rewrote = true;
    }
  }
  return { rewrote, search: merged, hash: "" };
}

function parseSearch(rawSearch: string): Record<string, string> {
  const out: Record<string, string> = {};
  const s = rawSearch.startsWith("?") ? rawSearch.slice(1) : rawSearch;
  if (!s) return out;
  const params = new URLSearchParams(s);
  for (const [k, v] of params) out[k] = v;
  return out;
}
